/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionSubtitleListItemWithCollectionSchema } from '../collection-subtitle-schema';

export const listCollectionSubtitlesResponseDataSchema = z.array(
  collectionSubtitleListItemWithCollectionSchema,
);

export type IListCollectionSubtitlesResponseData = z.infer<
  typeof listCollectionSubtitlesResponseDataSchema
>;

export const listCollectionSubtitlesResponseSchema = createApiResponseSchema(
  listCollectionSubtitlesResponseDataSchema,
) as z.ZodSchema<IAPI<IListCollectionSubtitlesResponseData>>;

export type IListCollectionSubtitlesResponse = IAPI<IListCollectionSubtitlesResponseData>;
